import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import { getGroups } from "../../../api/group";
import { AuthContext } from "../../../context/AuthContext";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { getIdenticator } from "../../../api/directory";

export function useShareGroupScreen() {
    const { setLoading,checkToken } = useContext(AuthContext);
    const route = useNavigate();
    const [add, setAdd] = useState(false);
    const [edit, setEdit] = useState(false);
    const [arrayGroups, setArrayGroups] = useState([]);
    const [srcFileZone, setSrcFileZone] = useState();

    useEffect(() => {
        _getGroups();
    }, []);

    async function _getGroups() {
        checkToken()
        let _return = false;
        setLoading(true);
        try {
            const dataGetGroups = await getGroups();
            setLoading(false);
            const res = dataGetGroups.data;
            if (res.code == "PROCESS_OK") {
                setArrayGroups(res.data.group);
            }
        } catch (error) {
            setLoading(false);
            const res = error.response.data;
            if (res.code == "NOT_FOUND") {
                // Swal.fire({
                //   title: "Código incorrecto",
                //   text: "",
                //   imageUrl: require("../../components/assets/images/advertir.png"),
                //   imageWidth: 150,
                //   imageHeight: 150,
                //   confirmButtonColor: "#fd6e0d",
                // });
            }
        }
        return _return;
    }

    const onClickGroups = (group) => {
        route("/ManageGroupScreen", {
            state: {
                group: group,
            },
        });
    };

    const formikAdd = useFormik({
        initialValues: {
            phoneNumber: "",
            directoryId: ""
        },
        onSubmit: async (values) => {
            formikAdd.setFieldValue("directoryId", "d6fdbe4b-de21-4b34-ab73-bff9dddee192");
            setEdit(true);
            // _getIdenticator(values.phoneNumber);
        },
        validate: (values) => {
            const errors = {};
            if (values.phoneNumber.inalidate)
                errors.phoneNumber = values.phoneNumber.message;
            return errors;
        },
    });

    async function _getIdenticator(phoneNumber) {
        checkToken()
        let _return = false;
        setLoading(true);
        try {
            const dataGetIdenticator = await getIdenticator(phoneNumber);
            setLoading(false);
            const res = dataGetIdenticator.data;
            if (res.code == "PROCESS_OK") {
                setEdit(true)
                // console.log(res.data);
                // const _res = await _addMemberByGroupIdByMemberId(data);
                // if (_res) {
                //   const _data = {
                //     directoryId: res.data.directoryId,
                //     phoneNumber: phoneNumber,
                //     preferredName: res.data.name,
                //   };
                //   arrayMembers.push(_data);
                // }
            }
        } catch (error) {
            setLoading(false);
            // const res = error.response.data;
            // if (res.code == "NOT_FOUND") {
            //   Swal.fire({
            //     title: "Código incorrecto",
            //     text: "",
            //     imageUrl: require("../../components/assets/images/advertir.png"),
            //     imageWidth: 150,
            //     imageHeight: 150,
            //     confirmButtonColor: "#fd6e0d",
            //   });
            // }
            Swal.fire({
                showCloseButton: true,
                title: "Esta persona no se encuentra registrada en Fiado",
                text: "",
                // imageUrl: require("../../components/assets/images/advertir.png"),
                imageWidth: 150,
                imageHeight: 150,
                confirmButtonColor: "#fd6e0d",
            });
        }
        return _return;
    }


    const formikEdit = useFormik({
        initialValues: {
            name: "",
            description: "",
        },
        onSubmit: async (values) => {
            console.log('values')
            //console.log(srcFileZone);
            // window.location.reload();
            // console.log({
            //     name: values.name,
            //     description: values.description,
            //     members: [
            //         {
            //             directoryId: formikAdd.values.directoryId
            //         }
            //     ]

            // });
        },
        validate: (values) => {
            const errors = {};
            if (!values.name) errors.name = "Campo Requerido";
            if (!values.description) errors.description = "Campo Requerido";
            return errors;
        },
    });

    // const arrayGroups = [
    //   {
    //     id: "44ee5342-b73d-43ff-ba3b-d7040e6be572",
    //     name: "Fiado",
    //     description: "Fiado Devs",
    //     onclick: () => {
    //       route("/ManageGroupScreen");
    //     },
    //   },
    // ];
    return {
        add, setAdd, formikAdd, edit, setEdit, arrayGroups, setArrayGroups, onClickGroups, formikEdit, srcFileZone, setSrcFileZone, route
    }
}